var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass:
        "dashboradControlsTop d-flex align-items-center justify-content-between fixed-top"
    },
    [
      _c("img", {
        staticClass: "img-fluid header__logo",
        attrs: {
          src: "assets/img/adoptuj-kravicku-logo.svg",
          alt: "adoptuj-kravicku-logo"
        }
      }),
      _vm._v(" "),
      _vm.$route.name == "kravicka"
        ? _c(
            "div",
            [
              _vm.profil.pouzivatel_id
                ? _c("menu-user-kravicka", {
                    attrs: { profil: _vm.profil, show: _vm.show },
                    on: {
                      hideBottomControls: function($event) {
                        return _vm.$emit("hideBottomControls")
                      },
                      "update:show": function($event) {
                        _vm.show = $event
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            [
              _vm.profil.pouzivatel_id
                ? _c("menu-user", { attrs: { profil: _vm.profil } })
                : _vm._e()
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }